import { Maybe, ENUM_COMPONENTSHAREDCTA_KIND } from './globalTypes'

import videoBlockFragmentRawString from '../../fragments/VideoBlockFragment.graphql'

export const videoBlockFragmentString = videoBlockFragmentRawString

export type VideoBlockFragment = {
  __typename: 'ComponentSectionsVideoBlocks'
  id: string
  videoBlock: Maybe<
    Maybe<{
      id: string
      isComponentRight: Maybe<boolean>
      title: string
      description: Maybe<string>
      video: {
        iframeSrc: string
        thumbnailUrl: {
          url: string
        }
      }
      primaryAction: {
        id: string
        label: string
        action: Maybe<string>
        url: Maybe<string>
        kind: ENUM_COMPONENTSHAREDCTA_KIND
      }
    }>[]
  >
}

export const isVideoBlockFragment = (
  fragment: any,
): fragment is VideoBlockFragment =>
  fragment &&
  fragment.__typename === 'ComponentSectionsVideoBlocks' &&
  typeof fragment.id === 'string' &&
  (fragment.videoBlock === null ||
    (Array.isArray(fragment.videoBlock) &&
      fragment.videoBlock
        .slice(0, 5)
        .reduce(
          (accum: any, next: any) =>
            accum &&
            (next === null ||
              (next &&
                typeof next.id === 'string' &&
                (next.isComponentRight === null ||
                  typeof next.isComponentRight === 'boolean') &&
                typeof next.title === 'string' &&
                (next.description === null ||
                  typeof next.description === 'string') &&
                next.video &&
                typeof next.video.iframeSrc === 'string' &&
                next.video.thumbnailUrl &&
                typeof next.video.thumbnailUrl.url === 'string' &&
                next.primaryAction &&
                typeof next.primaryAction.id === 'string' &&
                typeof next.primaryAction.label === 'string' &&
                (next.primaryAction.action === null ||
                  typeof next.primaryAction.action === 'string') &&
                (next.primaryAction.url === null ||
                  typeof next.primaryAction.url === 'string') &&
                (next.primaryAction.kind === 'external_url' ||
                  next.primaryAction.kind === 'internal_url' ||
                  next.primaryAction.kind === 'app_route' ||
                  next.primaryAction.kind === 'app_action'))),
          true,
        )))
